import { render } from "./BaseFeedbackScreenStructure.vue?vue&type=template&id=d1e16b38&scoped=true"
import script from "./BaseFeedbackScreenStructure.vue?vue&type=script&lang=js"
export * from "./BaseFeedbackScreenStructure.vue?vue&type=script&lang=js"

import "./BaseFeedbackScreenStructure.vue?vue&type=style&index=0&id=d1e16b38&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d1e16b38"]])

export default __exports__